var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoListsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2121_20734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 60.594C40.3492 60.594 43.875 57.0682 43.875 52.719C43.875 48.3698 40.3492 44.844 36 44.844C31.6508 44.844 28.125 48.3698 28.125 52.719C28.125 57.0682 31.6508 60.594 36 60.594Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.25 69.6C46.1625 67.561 44.5414 65.8559 42.5598 64.6669C40.5783 63.478 38.3109 62.85 36 62.85C33.6891 62.85 31.4217 63.478 29.4402 64.6669C27.4586 65.8559 25.8375 67.561 24.75 69.6",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.854 60.594C63.2032 60.594 66.729 57.0682 66.729 52.719C66.729 48.3698 63.2032 44.844 58.854 44.844C54.5048 44.844 50.979 48.3698 50.979 52.719C50.979 57.0682 54.5048 60.594 58.854 60.594Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.738 68.475C68.4411 66.64 66.7018 65.1622 64.6813 64.1789C62.6608 63.1955 60.4247 62.7385 58.1804 62.8501C55.9361 62.9617 53.7564 63.6384 51.8435 64.8174C49.9305 65.9963 48.3464 67.6394 47.238 69.594",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.146 60.594C17.4952 60.594 21.021 57.0682 21.021 52.719C21.021 48.3698 17.4952 44.844 13.146 44.844C8.79675 44.844 5.271 48.3698 5.271 52.719C5.271 57.0682 8.79675 60.594 13.146 60.594Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.262 68.475C3.55886 66.64 5.29822 65.1622 7.31869 64.1789C9.33917 63.1955 11.5753 62.7385 13.8196 62.8501C16.0639 62.9617 18.2436 63.6384 20.1565 64.8174C22.0695 65.9963 23.6536 67.6394 24.762 69.594",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.896 22.395L52.635 37.656L45.135 39.156L46.635 31.656L61.896 16.395C62.6897 15.6025 63.7654 15.1573 64.887 15.1573C66.0086 15.1573 67.0843 15.6025 67.878 16.395L67.896 16.413C68.2891 16.8056 68.601 17.2718 68.8138 17.785C69.0266 18.2983 69.1361 18.8484 69.1361 19.404C69.1361 19.9596 69.0266 20.5097 68.8138 21.0229C68.601 21.5362 68.2891 22.0024 67.896 22.395Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.674 9.00301L48.135 2.40601H12.135V36.156",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.135 18.156L24.135 21.156L30.135 15.156",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.135 33.156L24.135 36.156L30.135 30.156",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.635 19.656H42.135",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2121_20734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoListsIcon);
export default __webpack_public_path__ + "static/media/NoListsIcon.e18fd793c2e70fc7996ee0ffcaf62869.svg";
export { ForwardRef as ReactComponent };